/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetIntegrationConfigurationResponse } from '../../models/get-integration-configuration-response';

export interface GetByOrganizationId_5$Params {
  organizationId: string;
}

export function getByOrganizationId_5(http: HttpClient, rootUrl: string, params: GetByOrganizationId_5$Params, context?: HttpContext): Observable<StrictHttpResponse<GetIntegrationConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getByOrganizationId_5.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetIntegrationConfigurationResponse>;
    })
  );
}

getByOrganizationId_5.PATH = '/v1/organizations/{organizationId}/configuration/integration';
